module.exports = __webpack_public_path__ + "static/img/base-con-img.241ec1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCode/base-con-img.svg
// module id = /8Ff
// module chunks = 0